import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Modal, FormInput, FormSelect } from '../../components'
import { newStudyCase } from '../../api'
import { back, replace } from '../../actions/nav-actions';
import { retrieve } from '../../actions/project-actions';
import { notify } from '../../utils';

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal_visible: true,
        }
        this.onRequest = this.onRequest.bind(this);
    }
    onRequest(event) {
        if (event) event.preventDefault();
        newStudyCase(this.props.user.token, {
            ...this.state
        }).then((project) => {
            this.props.replace(`/projects/${project.organization}/${project.code}`);
        }).catch(err => {
            notify('Error!', err.message, 'error');
        })
    }
    render() {
        return (
            <Modal
                visible={this.state.modal_visible}
                onClose={() => this.setState({ modal_visible: false }, this.props.back)}
                title={'New Study Case'}
                action_text={"ADD STUDY CASE"}
                onActionClick={this.onRequest}>
                <form onSubmit={this.onRequest}>
                    <FormInput
                        onChange={(name) => {
                            this.setState({ name });
                        }}
                        required
                        value={this.state.name}
                        placeholder="Title" />
                    <FormInput
                        onChange={(description) => {
                            this.setState({ description });
                        }}
                        required
                        value={this.state.description}
                        placeholder="Brief description" />
                </form>
            </Modal>
        )
    }
}

const mapStateToProps = state => ({ user: state.authReducer.user })

const mapDispatchToProps = dispatch => ({
    back() {
        dispatch(back());
    },
    retrieve(token) {
        dispatch(retrieve(token));
    },
    replace(routeName) {
        dispatch(replace(routeName))
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(Form)


// WEBPACK FOOTER //
// ./src/routers/StudyCases/Form.js